import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Zap, Users, ArrowRight } from 'lucide-react';

export default function SobrePage() {
    return (
        <div className="min-h-screen" style={{ background: 'var(--bg)' }}>
            {/* Hero */}
            <section className="py-16 md:py-24 text-center px-4">
                <div className="max-w-3xl mx-auto">
                    <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{ color: 'var(--text)', fontFamily: "var(--font-display)" }}>
                        Sobre a <span style={{ color: 'var(--gold-2)' }}>SuperVitrine</span>
                    </h1>
                    <p className="text-base md:text-lg leading-relaxed" style={{ color: 'var(--muted)' }}>
                        Nascemos com a missão de conectar pessoas às melhores ofertas da internet,
                        usando tecnologia e curadoria para que você economize com inteligência.
                    </p>
                </div>
            </section>

            {/* Values */}
            <section className="max-w-5xl mx-auto px-4 pb-16 grid grid-cols-1 md:grid-cols-3 gap-6">
                {[
                    { icon: Zap, title: 'Agilidade', desc: 'Rastreamos ofertas em tempo real para você nunca perder uma oportunidade.' },
                    { icon: Shield, title: 'Confiança', desc: 'Curadoria rigorosa para garantir que cada oferta publicada seja real e vantajosa.' },
                    { icon: Users, title: 'Comunidade', desc: 'Uma rede colaborativa onde todos contribuem para encontrar os melhores preços.' },
                ].map((v) => (
                    <div key={v.title} className="rounded-xl p-6 text-center" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
                        <div className="w-12 h-12 rounded-xl mx-auto mb-4 flex items-center justify-center" style={{ background: 'rgba(var(--sv-accent-rgb), 0.08)' }}>
                            <v.icon size={22} style={{ color: 'var(--gold-2)' }} />
                        </div>
                        <h3 className="text-sm font-bold mb-2" style={{ color: 'var(--text)', fontFamily: "var(--font-display)" }}>{v.title}</h3>
                        <p className="text-xs leading-relaxed" style={{ color: 'var(--muted)' }}>{v.desc}</p>
                    </div>
                ))}
            </section>

            {/* CTA */}
            <section className="max-w-3xl mx-auto px-4 pb-20 text-center">
                <div className="rounded-xl p-8" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
                    <h2 className="text-base md:text-lg font-bold mb-3" style={{ color: 'var(--text)', fontFamily: "var(--font-display)" }}>
                        Quer fazer parte?
                    </h2>
                    <p className="text-xs mb-5" style={{ color: 'var(--muted)' }}>
                        Junte-se a milhares de pessoas que já economizam todos os dias com a SuperVitrine.
                    </p>
                    <Link to="/login" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-semibold transition-all hover:scale-105" style={{ background: 'var(--gold-2)', color: '#0A0A0A' }} data-testid="sobre-cta-btn">
                        Criar minha conta <ArrowRight size={14} />
                    </Link>
                </div>
            </section>
        </div>
    );
}
